import axios from 'axios';
import IdentityService from './identity.service.js';

const apiUrl = process.env.API_URL;

export default function() {
  axios.interceptors.request.use(function (config: any) {
    if(IdentityService.getFingerprint()){
      if(config.url.startsWith(apiUrl)){
        config.headers['PF-IDENTITY'] = IdentityService.getFingerprint();
      }
    }

    return config;
  });

  //Intercept response and prepare the error object
  axios.interceptors.response.use((response) => {
    return response
  }, (error) => {
    console.log("Unknown error :" + error);
    
    let errorMessage = '';

    if(error.response && error.response.data) {
      return Promise.reject(error.response.data);
    } else {    
      return Promise.reject({
        code: '99999',
        message: "Oops, Unable to complete the request"
      });
    }
  });
}